export const purchaseUrls = {
  base: 'https://www.compradigitalya.com/cart/43054167359559:1',
  premium: 'https://www.compradigitalya.com/cart/43054169096263:1',
}

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/hpbhHt4vseCPUBsb5St8n1/ChatGPT_Image_7_ago_2026,_11_37_47_a.m..png'

export const testimonials = [
  {
    initials: 'SV',
    name: 'Sandra V.',
    place: 'Buenos Aires, Argentina · 47 años · Profesora de Educación Física',
    text: 'Trabajo en un centro de jubilados y nunca tuve un sistema ordenado. Siempre improvisaba. Desde que tengo el Tomo 1, las clases arrancaron con una evaluación real, asigné niveles a cada alumno y el programa se estructura solo. Mis alumnos notaron la diferencia desde la primera semana.',
  },
  {
    initials: 'MR',
    name: 'Marcelo R.',
    place: 'Córdoba, Argentina · 38 años · Entrenador Personal',
    text: 'Soy entrenador personal y no sabía cómo trabajar con adultos mayores más allá de los ejercicios básicos. El Tomo 3 me dio circuitos completos, adaptaciones para cada nivel y clases listas para dictar. Pasé de tenerle miedo a esa población a tener una lista de espera.',
  },
  {
    initials: 'CL',
    name: 'Claudia L.',
    place: 'Rosario, Argentina · 42 años · Kinesióloga',
    text: 'Trabajo como kinesióloga y empecé a dar clases grupales de adultos mayores como complemento. Los Tomos 4 y 5 me sorprendieron. El trabajo de potencia muscular, el Dual Task y los circuitos recreativos están explicados con un nivel técnico real. Es el material más completo que encontré en español.',
  },
  {
    initials: 'GA',
    name: 'Gustavo A.',
    place: 'Mendoza, Argentina · 54 años · Coordinador de Centro de Jubilados',
    text: 'Coordino tres grupos de adultos mayores en la municipalidad y el problema siempre fue la falta de continuidad entre semanas. Con las 52 semanas ya planificadas dejé de improvisar y pude sumar un cuarto grupo. La evaluación inicial también nos sirvió para mostrarle resultados concretos a la secretaría de salud.',
  },
  {
    initials: 'PM',
    name: 'Patricia M.',
    place: 'La Plata, Argentina · 45 años · Profesora de Gimnasia Adaptada',
    text: 'Tengo alumnas con artrosis, osteoporosis y una con prótesis de cadera. Antes cada clase era una duda. Con las adaptaciones del Mega Kit y los juegos recreativos del Bono 4 armo clases donde todas participan según su nivel. En seis meses no perdí ni una alumna.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'Evaluación Inicial + Nivel Principiante I',
    period: 'Semanas 1 a 9 — Sistema CompraDigitalYa™',
    content: [
      'Protocolo de evaluación inicial completo con 8 tests validados: Chair Stand, TUG, Apoyo Monopodal, Sit and Reach, Back Scratch y Test de Resistencia.',
      'Sistema de clasificación por niveles basado en los resultados de la evaluación.',
      '27 clases completamente desarrolladas con ejercicios, series, repeticiones, adaptaciones y progresiones.',
      'Estructura estándar de clase con calentamiento, parte principal, equilibrio, coordinación, cardiovascular y vuelta a la calma.',
      'Planilla de seguimiento individual y ficha de evaluación lista para imprimir.',
    ],
  },
  {
    icon: '📗',
    name: 'Nivel Principiante II',
    period: 'Semanas 10 a 18 — Sistema CompraDigitalYa™',
    content: [
      '27 clases progresivas que continúan el nivel principiante con mayor complejidad, carga y variedad.',
      'Introducción al trabajo de equilibrio con superficie inestable, bastones y pelotas.',
      'Primeras coreografías de coordinación de 4 y 6 pasos con música.',
      'Trabajo cardiovascular progresivo con intervalos básicos adaptados.',
      'Reevaluación de bloque con comparación de resultados respecto a la Semana 1.',
    ],
  },
  {
    icon: '📙',
    name: 'Nivel Intermedio',
    period: 'Semanas 19 a 27 — Sistema CompraDigitalYa™',
    content: [
      'Introducción al trabajo con bandas elásticas, mancuernas livianas y bastones en circuitos funcionales.',
      'Trabajo de equilibrio dinámico: tándem completo, paso en estrella y transferencias de peso.',
      'Primeros circuitos recreativos de alta participación grupal.',
      'Introducción al trabajo de Dual Task básico: ejercicio físico y tarea cognitiva simultáneos.',
      '27 clases listas para dictar con todas las adaptaciones por nivel incluidas.',
    ],
  },
  {
    icon: '📕',
    name: 'Nivel Intermedio Avanzado',
    period: 'Semanas 28 a 36 — Sistema CompraDigitalYa™',
    content: [
      'Trabajo de fuerza con protocolos de carga progresiva y tempo diferenciado.',
      'Dual Task avanzado: doble tarea cognitivo-motora en todos los ejercicios principales.',
      'Circuitos recreativos de alta complejidad con pelotas, conos, globos y pañuelos.',
      'Coreografías de 8 y 10 pasos con variantes de velocidad y dirección.',
      '27 clases completamente desarrolladas con los circuitos más variados del programa.',
    ],
  },
  {
    icon: '📓',
    name: 'Nivel Avanzado',
    period: 'Semanas 37 a 45 — Sistema CompraDigitalYa™',
    content: [
      'Introducción al trabajo de potencia muscular con protocolo de velocidad diferencial en sentadillas, remo y bisagra de cadera.',
      'Equilibrio avanzado: apoyo unipodal en colchoneta, perturbaciones externas y Dual Task simultáneo.',
      'Los Grandes Juegos Funcionales: Las 8 Hazañas, El Olimpo de la Salud y los circuitos de máxima complejidad.',
      'Tai Chi de 8 movimientos integrado al programa de coordinación.',
      '27 clases de la mayor complejidad técnica del programa con todas las adaptaciones incluidas.',
    ],
  },
  {
    icon: '📔',
    name: 'Nivel Avanzado II + Planificación Final',
    period: 'Semanas 46 a 52 — Sistema CompraDigitalYa™',
    content: [
      'Evaluación final anual completa con comparación de los 8 tests desde la Semana 1 hasta la Semana 52.',
      'Informe individual de progreso anual para entregar a cada alumno.',
      'Protocolo de transición al segundo año del programa.',
      'Estrategias de adherencia a largo plazo y programa personal post-ciclo.',
      'Certificado de finalización del programa, ceremonia de cierre y recursos de proyección hacia el segundo año.',
    ],
  },
]

export const bonuses = [
  [
    '01',
    '🦴',
    'Atlas Premium de Movilidad Articular',
    'Rutinas completas de movilidad articular para cuello, hombros, codos, muñecas, columna, caderas, rodillas y tobillos. Rutinas de 5, 10, 15 y 20 minutos listas para aplicar antes de cualquier clase. Versión sentada, de pie y con bastón. Ideal para todos los niveles.',
    '$12.000',
  ],
  [
    '02',
    '🧘',
    'Biblioteca Premium de Estiramientos Seguros',
    'Biblioteca completa de estiramientos organizados por grupo muscular, posición y momento de la clase. Variantes en silla, de pie y en colchoneta. Rutinas de 5, 10, 15 y 20 minutos para antes y después de cualquier entrenamiento. Checklist de vuelta a la calma imprimible.',
    '$12.000',
  ],
  [
    '03',
    '🏋️',
    'Mega Biblioteca Funcional de Ejercicios',
    'Más de 80 ejercicios organizados por fuerza, equilibrio, coordinación, marcha, resistencia, movilidad, flexibilidad y core. Cada ejercicio incluye progresiones para principiante, intermedio y avanzado. Banco de reemplazo para adaptar cualquier clase en segundos.',
    '$14.000',
  ],
  [
    '04',
    '🎯',
    'Juegos Funcionales y Actividades Recreativas',
    'Más de 60 juegos funcionales con pelotas, globos, conos, música, bastones, pañuelos y sillas. Clasificados por objetivo: memoria, coordinación, equilibrio, integración, diversión y reacción. Listos para insertar en cualquier clase grupal.',
    '$12.000',
  ],
  [
    '05',
    '🏠',
    'Entrenamientos en Casa para Adultos Mayores',
    'Programas completos de 20, 30 y 45 minutos sin materiales, con silla, con banda elástica, con botellas y con palo de escoba. Para que tus alumnos se mantengan activos entre clases. Plan semanal y protocolo de reincorporación post-interrupción incluidos.',
    '$12.000',
  ],
  [
    '06',
    '⚡',
    '100+ Circuitos Listos para Usar',
    'Más de 100 circuitos clasificados por fuerza, cardio, equilibrio, coordinación, movilidad, prevención de caídas, poco material y grupos grandes. Cada circuito incluye objetivo, materiales, nivel, tiempos y adaptaciones. Seleccioná el circuito correcto en 30 segundos.',
    '$14.000',
  ],
] as const

export const faqs = [
  [
    '¿Sirve si recién empiezo a trabajar con adultos mayores?',
    'Sí. El sistema está diseñado para que cualquier profesional del movimiento, aunque no tenga experiencia previa con adultos mayores, pueda aplicar los programas de forma segura y efectiva desde el primer día. Cada clase está completamente desarrollada con ejercicios explicados paso a paso, series, repeticiones, adaptaciones y progresiones. No es necesario improvisar nada.',
  ],
  [
    '¿Cómo recibo el material?',
    'Después de confirmar el pago, recibís un correo a tu dirección de mail con el enlace de descarga. El acceso es inmediato, en menos de 5 minutos ya tenés todos los archivos PDF en tu dispositivo. Podés guardarlos en tu teléfono, tablet o computadora y usarlos offline en cualquier momento.',
  ],
  [
    '¿La garantía es real?',
    'Completamente real. Tenés 7 días para abrir los materiales, revisarlos y aplicarlos. Si por cualquier razón no es lo que esperabas, escribís a compradigitalya@gmail.com y te devolvemos el 100% del dinero sin preguntas, sin formularios y sin demoras. El riesgo es nuestro, no tuyo.',
  ],
  [
    '¿Qué necesito para empezar?',
    'Solo necesitás un espacio con sillas, un grupo de adultos mayores y las ganas de trabajar con un sistema real. El primer paso es aplicar la evaluación inicial del Tomo 1 para asignar niveles. A partir de ahí, el programa te guía semana a semana durante todo el año.',
  ],
  [
    '¿Sirve para trabajar con grupos o también con alumnos individuales?',
    'Sirve para los dos. Los tomos están diseñados para clases grupales pero cada clase incluye adaptaciones individuales, versiones de menor y mayor complejidad y criterios de progresión que permiten trabajar con alumnos de distintos niveles en la misma sesión. También podés usar los programas del Bono 5 para sesiones individuales o domiciliarias.',
  ],
  [
    '¿Puedo usarlo en un gimnasio, centro de jubilados o municipalidad?',
    'Sí. El sistema es perfectamente aplicable en gimnasios, centros de jubilados, clubes, municipalidades y cualquier espacio donde se trabajen clases con adultos mayores. No requiere equipamiento costoso: la mayoría de las clases se dictan con sillas, bandas elásticas y pelotas básicas.',
  ],
  [
    '¿Está adaptado para Argentina y puedo imprimirlo?',
    'Sí. El material está redactado en español neutro con adaptaciones al contexto argentino. Todos los PDFs pueden imprimirse en formato A4 en cualquier imprenta o en tu propia impresora. Las fichas de evaluación y seguimiento están especialmente diseñadas para ser impresas y usadas como herramientas físicas de registro.',
  ],
  [
    '¿Qué pasa si mis alumnos tienen patologías como Parkinson, artrosis o prótesis?',
    'El Combo incluye adaptaciones en cada clase para las limitaciones más frecuentes. Si trabajás habitualmente con patologías, el Mega Kit suma la guía maestra con protocolos específicos para 12 condiciones de salud: Parkinson, ACV, osteoporosis, artrosis, hipertensión, diabetes, prótesis de cadera y rodilla, entre otras.',
  ],
  [
    '¿Cuánto tiempo me lleva preparar una clase con el sistema?',
    'Menos de 5 minutos. Abrís el tomo correspondiente, buscás la semana en la que está tu grupo y la clase ya está desarrollada de principio a fin: calentamiento, parte principal, equilibrio, coordinación, cardiovascular y vuelta a la calma, con materiales y adaptaciones indicadas.',
  ],
  [
    '¿Puedo pagar en cuotas y es seguro?',
    'Sí. El pago se procesa a través de Mercado Pago, con hasta 12 cuotas y todos los medios habituales: tarjeta de crédito, débito, transferencia y dinero en cuenta. La operación es 100% segura y el acceso al material se envía automáticamente al confirmarse el pago.',
  ],
] as const

export const recentPurchases = [
  ['Sandra V.', 'Buenos Aires', 'Combo Completo Adultos Mayores'],
  ['Marcelo R.', 'Córdoba', 'Combo Completo + Mega Kit'],
  ['Claudia L.', 'Rosario', 'Combo Completo Adultos Mayores'],
  ['Gustavo A.', 'Mendoza', 'Combo Completo + Mega Kit'],
  ['Patricia M.', 'La Plata', 'Combo Completo Adultos Mayores'],
  ['Norberto D.', 'Mar del Plata', 'Combo Completo Adultos Mayores'],
  ['Silvina P.', 'Salta', 'Combo Completo + Mega Kit'],
  ['Rubén O.', 'Neuquén', 'Combo Completo Adultos Mayores'],
  ['Mónica E.', 'San Miguel de Tucumán', 'Combo Completo + Mega Kit'],
  ['Alejandro F.', 'Bahía Blanca', 'Combo Completo Adultos Mayores'],
] as const
